(()=>{
  "use strict";
  var results_graph = undefined;
  /**
   * ------------------------------------------------------------------------
   * Method's
   * ------------------------------------------------------------------------
   **/
  var getTasks = (strategy_id) => {
    return $.ajax({
      url: $("#tasks").data('url'),
      method: 'GET',
      data: { strategy_id: strategy_id },
      beforeSend: () => { $("#tasks").prop('disabled', true); }
    });
  };

  var drawChart = () => {
    let colors = { 1: '#93CAC5', 2: '#82C0D9', 3: '#2B678C', 4: '#147ab7', 5: '#114a95' },
        I18N = { es: { title_chart: 'Capacidad Instalada' }, en: { title_chart: 'Existing Capacity' } };

    fetch(`${$("#strategies").data('url-info')}?strategy=${$("#strategies").val()}&task=${$("#tasks").val()}`).then((response) => {
      return response.json()
    }).then((json) => {
      if (results_graph !== undefined) {
        results_graph.destroy();
      }

      results_graph = new Chart(document.getElementById('results_graph').getContext('2d'), {
        type: 'horizontalBar',
        data: {
          labels: json.map((el) => { return el[0] }),
          datasets: [{
            label: I18N[$("html").attr('lang')]['title_chart'],
            backgroundColor: json.map((el) => { return colors[el[1]] }),
            borderColor: [],
            data: json.map((el) => { return el[1] })
          }]
        },
        options: {
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero:true,
                precision: 0,
                stepSize: 1,
                suggestedMax: 5
              }
            }]
          }
        }
      });
    });
  };

  var drawGaps = () => {
    $.ajax({
      url: $("#strategies").data('url-gaps'),
      method: 'GET',
      data: { 
        strategy: $("#strategies").val(),
        task: $("#tasks").val()
      }
    }).done((data) => {
      let body_html = '',
          i18n_gaps = $("#strategies").data('i18n-gaps'),
          summary_gaps = {},
          type_capacity = '',
          number_gap = $("#type-fesp").data('fesp').toLowerCase().replace( /^\D+/g, '');
      $(`#summary-gaps tbody td[id^=summary-gap]`).each((k, v) => { summary_gaps[$(v).attr('id').replace('summary-gap-', '')] = 0 });
      
      $(data.gaps).each((key, val) => {
        $(val.gaps).each((k, v) => {
          type_capacity = data.type_capacities[v.type_capacity_id][0];
          try {
            body_html += `<tr>
              <td style="background-color: ${type_capacity.capacity_bgcolor}; color: ${type_capacity.capacity_textcolor};">
                ${v.type_capacity}
              </td>
              <td>${v.strategy_text}</td>
              <td>
                ${(number_gap === '10') ? i18n_gaps[$("#type-fesp").data('fesp').toLowerCase()][v.type_capacity_id][v.strategy_code][v.criterion] : i18n_gaps[$("#type-fesp").data('fesp').toLowerCase()][v.type_capacity_id][v.criterion]}
              </td>
              <td>
                <a class="${data.gaps_completed[v.type_capacity_id + "." + (($("#type-fesp").data('fesp').toLowerCase() === 'fesp10' || $("#type-fesp").data('fesp').toLowerCase() === 'ephf10') ? v.strategy_code : '') + "." + v.criterion] !== undefined ? "text-success" : "text-warning"} " href="/tracking_gaps/new?evaluation_header=${$("#table-gaps").data('evaluation-header')}&capacity=${v.type_capacity_id}&strategy=${v.strategy_code}&criterion=${v.criterion}"><i class= "fas fa-pencil-alt"></i></a>
              </td>
            </tr>`;
          } catch (error) {
            console.log(error);
          }
        });
      });

      $("#summary-gaps tbody td:nth-child(2)").data('exists', false).html(0);
      
      $(data.gaps).each((k, v) => {
        try {
          $(`#summary-gaps tbody td#summary-gap-${v.capacity_id}`).data('exists', true).html(`${v.gaps.length} / ${data.total_gaps[v.capacity_id][0].total_gaps}`);
        } catch (error) {
          $(`#summary-gaps tbody td#summary-gap-${v.capacity_id}`).data('exists', true).html(`0 / 0`);
        }
      });

      $("td[id^='summary-gap']").each((k,v) => {
        if ($(v).data('exists')) {
          $(v).parent().removeClass('d-none');
        } else {
          $(v).parent().addClass('d-none');
        }
      });

      $("#table-gaps").DataTable().destroy();
      $("#table-gaps tbody").html(body_html);
      CtrlDatatable.sync_tables("#table-gaps");
    });
  };

  var changeStrategy = () => {
    let I18N = { es: { all: 'Todos' }, en: { all: 'All' } };

    $("#strategies").change((e) => {
      $(e.currentTarget).prop('disabled', true);
      getTasks($(e.currentTarget).val()).done((data) => {
        let new_options = `<option value="0">${I18N[$("html").attr('lang')]['all']}</option>`;
        $(data).each((k,v) => {
          new_options += `<option value="${v.id}">${v.body}</option>`
        });
        $("#tasks").html(new_options).select2();
        $("#tasks").prop('disabled', false);

        //new Chartkick.BarChart("strategy_chart", $(e.currentTarget).data('url-info') + '?strategy=' + $(e.currentTarget).val() + '&task=' + $("#tasks").val(), { max: 5, min: 0, xtitle: $(e.currentTarget).data('x-title'), library: { scales: { xAxes: [ { ticks: { precision: 0, stepSize: 1 } } ] } } })
        drawChart();
        drawGaps();
        
        $(e.currentTarget).prop('disabled', false);
      });
    });
  };

  var changeTask = () => {
    $("#tasks").change((e) => {
      //new Chartkick.BarChart("strategy_chart", $("#strategies").data('url-info') + '?strategy=' + $("#strategies").val() + '&task=' + $("#tasks").val(), { max: 5, min: 0, xtitle: $(e.currentTarget).data('x-title'), library: { scales: { xAxes: [ { ticks: { precision: 0, stepSize: 1 } } ] } } })
      drawChart();
      drawGaps();
    });
  };

  const showDetailGaps = () => {
    Array.from(document.getElementsByClassName('show-detail-gaps')).forEach(element => {
      element.addEventListener('click', (event) => {
        let target = event.target,
            gaps = JSON.parse(target.getAttribute('data-gaps-detail')),
            fesp_gaps = JSON.parse(document.getElementById('detail-unified-gaps').getAttribute('data-fesp-gaps')),
            capacities = JSON.parse(document.getElementById('detail-unified-gaps').getAttribute('data-capacities')),
            config_capacities = JSON.parse(document.getElementById('detail-unified-gaps').getAttribute('data-config-capacities')),
            html = '';

        document.getElementById('unified-gap-text').innerHTML = target.innerHTML;

        gaps.forEach(gap => {
          html += `<tr>
            <td style="background-color: ${config_capacities[gap[0]][0].capacity_bgcolor}; color: ${config_capacities[gap[0]][0].capacity_textcolor};">
              ${capacities[gap[0]]}
            </td>
            <td>
              ${fesp_gaps[gap[0]][gap[1]]}
            </td>
          </tr>`;
        });

        $("#detail-unified-gaps").DataTable().destroy();
        document.querySelector('#detail-unified-gaps tbody').innerHTML = html;
        CtrlDatatable.sync_tables("#detail-unified-gaps");
        $('#modal-unified-gap-detail').modal('show');
      });
    });
  };

  const replaceUnifiedGapsWithUniqueGaps = () => {
    try {
      let fesp_gaps = JSON.parse(document.getElementById('detail-unified-gaps').getAttribute('data-fesp-gaps')),
        capacities = JSON.parse(document.getElementById('detail-unified-gaps').getAttribute('data-capacities')),
        config_capacities = JSON.parse(document.getElementById('detail-unified-gaps').getAttribute('data-config-capacities')),
        current_gap, capacity_unified;

      document.querySelectorAll('.show-detail-gaps[data-total-gaps="1"]').forEach(unified_gap => {
        current_gap = JSON.parse(unified_gap.getAttribute('data-gaps-detail'))[0];
        capacity_unified = document.getElementById(`unified-gap-capacity-${unified_gap.getAttribute('data-unified-gap-id')}`);
        
        capacity_unified.style.backgroundColor = config_capacities[current_gap[0]][0].capacity_bgcolor;
        capacity_unified.style.color = config_capacities[current_gap[0]][0].capacity_textcolor;
        
        capacity_unified.innerHTML = capacities[current_gap[0]];
        unified_gap.innerHTML = fesp_gaps[current_gap[0]][current_gap[1]];
      });

      $("#table-unified-gaps").DataTable().destroy();
      CtrlDatatable.sync_tables("#table-unified-gaps");
    } catch (error) {
      error;
    }
  };

  document.addEventListener('turbolinks:load', ()=>{
    changeStrategy();
    changeTask();
    //replaceUnifiedGapsWithUniqueGaps();
    //showDetailGaps();

    $("#strategies").trigger('change');
  });
})();